/**
 * AWS Cognito configuration for frontend SSO integration.
 * These values should match your backend configuration.
 * Environment variables are prefixed with VITE_ to be accessible in the browser.
 */

export const cognitoConfig = {
  region: import.meta.env.VITE_COGNITO_REGION,
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  webimaxClientId: import.meta.env.VITE_COGNITO_CLIENT_ID_WEBIMAX,
  identityProvider: import.meta.env.VITE_COGNITO_IDENTITY_PROVIDER,
  webimaxIdentityProvider: import.meta.env.VITE_COGNITO_IDENTITY_PROVIDER_WEBIMAX,
  domain: import.meta.env.VITE_COGNITO_DOMAIN,
  redirectUri:
    typeof window !== "undefined"
      ? `${window.location.origin}/auth/callback`
      : import.meta.env.VITE_COGNITO_REDIRECT_URI,

  // OAuth scopes
  scopes: ["openid", "email", "profile", "phone", "aws.cognito.signin.user.admin"],

  // Response type for authorization code flow
  responseType: "code",
};

export default cognitoConfig;
